<div class="external-widget widget-item">
  <div class="header" *ngIf="title">
    <div class="title">{{ title }}</div>
  </div>
  <div class="widget-body">
    <div class="permission-denied-area">
      <comp-icon [icon]="'do_not_disturb_on'" [size]="32" [color]="'#87909f'"></comp-icon>
      <div class="permission-denied-text">Permission Denied</div>
      <div class="permission-key-text" *ngIf="permissionKey">{{ permissionKey }}</div>
    </div>
  </div>
</div>
